/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type AgeCategoryDictionaryDto = {
    key?: AgeCategoryDictionaryDto.key;
    displayValue?: string;
};
export namespace AgeCategoryDictionaryDto {
    export enum key {
        JUNIOR_STARSZY = 'JUNIOR_STARSZY',
        JUNIOR_MLODSZY = 'JUNIOR_MLODSZY',
        TRAMPKARZ = 'TRAMPKARZ',
        MLODZIK = 'MLODZIK',
        ORLIK = 'ORLIK',
        ZAK = 'ZAK',
        SKRZAT = 'SKRZAT',
    }
}

